module.exports = __webpack_public_path__ + "img/layout-edit.3560d000.svg";